import { render, staticRenderFns } from "./ProductPageSchema.vue?vue&type=template&id=5b5c568a&"
import script from "./ProductPageSchema.vue?vue&type=script&lang=js&"
export * from "./ProductPageSchema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports